export const comingSoon = {
	bars: {
		title: "Agregar barras",
		message: "Esta función se implementará pronto",
	},
	mountableProduct: {
		title: "Producto montable",
		message: "Esta función se implementará pronto",
	},
	technicalSheet: {
		title: "Agregar ficha técnica",
		message: "Esta función se implementará pronto",
	},
};
